module.exports = __webpack_public_path__ + "static/media/d.281767b4.svg";